import React from 'react'

// Components
import {
  Flex,
  CopyToClipboard,
  Text,
  TruncateWithTooltip,
  useForTablet,
} from '@sketch/components'
import {
  StyledModal as Modal,
  Title,
  PreviewImage,
  PreviewImageEmpty,
} from './SharingModal.styles'

// Types
import { ShareInfoWithCollectionFragment } from '@sketch/gql-types'

const ShareLocation: React.FC<{
  share?: ShareInfoWithCollectionFragment
}> = ({ share }) => {
  if (!share) {
    return null
  }

  if (share.project) {
    return (
      <TruncateWithTooltip width={350}>
        <Text.Span textStyle="copy.tertiary.standard.D">
          {share.project.name} <strong>/ {share.workspace.name}</strong>
        </Text.Span>
      </TruncateWithTooltip>
    )
  }

  return (
    <TruncateWithTooltip width={350}>
      <Text.Span textStyle="prominent.secondary.D">
        {share.workspace.name}
      </Text.Span>
    </TruncateWithTooltip>
  )
}

interface SharingModalHeaderProps {
  share?: ShareInfoWithCollectionFragment
}

export const SharingModalHeader = ({ share }: SharingModalHeaderProps) => {
  const isTabletAndBigger = useForTablet()
  const thumbnails = share?.version?.document?.previewFile?.thumbnails
  const image = thumbnails ? thumbnails[0]?.url : undefined

  return (
    <Modal.Header>
      <Flex alignItems="center" mb={6} height={92}>
        {image ? (
          <PreviewImage alt={share?.name ?? ''} src={image} />
        ) : (
          <PreviewImageEmpty data-testid="share-image-placeholder" />
        )}
        <Flex ml={6} mr={6} flex={1} flexDirection="column">
          <Title>
            <strong>Share:</strong> {share?.name ?? '&hellip;'}
          </Title>
          <ShareLocation share={share} />
        </Flex>
        {share && isTabletAndBigger && (
          <CopyToClipboard
            size="40"
            showIcon={false}
            value={share.publicUrl}
            title={
              share.publicAccessLevel !== 'NONE'
                ? 'Copy Public Link'
                : 'Copy Link'
            }
          />
        )}
      </Flex>
    </Modal.Header>
  )
}
